import { Component, OnInit } from '@angular/core';
import { DariCalendarService } from '../../../services/DariCalendar';
import { ReportService } from '../../../services/Acc_ReportService';
import { MatSnackBar } from '@angular/material';
import * as $ from 'jquery';
@Component({
  selector: 'app-student-finance-report',
  templateUrl: './student-finance-report.component.html',
  styleUrls: ['./student-finance-report.component.css'],
})
export class StudentFinanceReportComponent implements OnInit {
  constructor(private ReportService: ReportService, private DariCalendar: DariCalendarService, public snack: MatSnackBar) { }
  studentID;
  studentDetails: any = {};
  financeDetails: any = [];
  semesters: any = {};
  sumOfFees = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  sumOfDiscounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  sumOfPayablesP = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  sumOfFeePaidable = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  sumOfPayablesN = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  percentOfPaid = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  percentOfUnPaid = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  originalFee = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  discountValue = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
  semster = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
  semsterYear = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
  semsterSeaon = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
  
  totalFees: number = 0;
  totalDiscount: number = 0;
  totalPayable: number = 0;
  printable: boolean = false;
  ngOnInit() { }
  searchStudent() {
    console.log(this.studentID);
    if (this.studentID === null || this.studentID === undefined) {
      this.snack.open('لطفا حساب کاربردی محصل را مشخص کنید.', '', { duration: 5000 });
    } else {
      this.ReportService.getStudentDetails(this.studentID).subscribe(
        r => {
          if (r) {  // if student found
            this.studentDetails = r;
            console.log(this.studentDetails);
            this.studentDetails["reportDate"] = this.DariCalendar.PersianCalendar(new Date(this.studentDetails["reportDate"]));
            this.ReportService.getSemesters(this.studentDetails["studentID"]).subscribe(r => {
              this.semesters = r;
              console.log(r);
            });
            this.sumOfFees = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.sumOfDiscounts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.sumOfPayablesP = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.sumOfPayablesN = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.sumOfFeePaidable = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.percentOfPaid = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.percentOfUnPaid = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.originalFee = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.discountValue = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0, 16: 0 };
            this.semsterYear = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
            this.semsterSeaon = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
            this.semster = { 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '', 11: '', 12: '', 13: '', 14: '', 15: '', 16: '' };
            this.totalFees = 0;
            this.totalDiscount = 0;
            this.totalPayable = 0;
            this.ReportService.getStudentFinanceReport(this.studentDetails["studentID"]).subscribe(
              a => {
                if (a) {
                  for (let date in a) {
                     
                    console.log(a[date]);
                    a[date]["issueDate_da"] = this.DariCalendar.PersianCalendar(new Date(a[date]["issueDate"])); 
                    //a[date]["issueDate"] = this.DariCalendar.PersianCalendar(new Date(date)).substring(0, 9);
                    this.sumOfFees[a[date]["semester"]] += a[date]["fee"];
                    this.sumOfDiscounts[a[date]["semester"]] += a[date]["discount"];
                    this.sumOfPayablesP[a[date]["semester"]] += a[date]["isPayed"] === 'Y' ? a[date]["payable"] : 0;
                    
                    this.sumOfPayablesN[a[date]["semester"]] += a[date]["isPayed"] === 'N' ? a[date]["payable"] : 0;
                    this.originalFee[a[date]["semester"]] = a[date]["originalFee"];
                    this.discountValue[a[date]["semester"]] = a[date]["discountValue"];
                    this.semsterSeaon[a[date]["semester"]] = a[date]["season"] == 1 ? 'بهاری' : 'خزانی';
                    this.semsterYear[a[date]["semester"]] = a[date]["year"];
                  }
                   
                  for (let i = 1; i <= 16; i++) {
                    this.totalFees += this.sumOfFees[i];
                    this.totalDiscount += this.sumOfDiscounts[i];
                    this.totalPayable += this.sumOfPayablesP[i];
                    this.sumOfFeePaidable[i] = ((this.originalFee[i]) - (this.originalFee[i]) * (this.discountValue[i]) / 100);
                    this.percentOfPaid[i] += ((this.sumOfPayablesP[i]) * 100.0 / (this.originalFee[i]));
                    this.percentOfUnPaid[i] += ((this.sumOfPayablesN[i]) * 100.0 / (this.originalFee[i]));
                  }
                  console.log(this.sumOfFees);
                  console.log(this.sumOfDiscounts);
                  console.log(this.sumOfPayablesP);
                  this.financeDetails = a;
                  this.printable = true;
                  console.log("Finance Details: ");
                  console.log(a);
                }
              }
            );
          }
        }
      );
    }
  }

  printReport(pageNumber: number) {
    if (this.printable) {
      var content = $(`#printPaper${pageNumber}`).prop('outerHTML');
      var _style = $('style');
      var _script = $('script');
      var windowP = window.open('', '', '');
      windowP.document.write('<html><head><title>Print</title>');
      for (var i = 0; i < _style.length; i++)
        windowP.document.write(_style[i].outerHTML);
      windowP.document.write('</head><body class="rtl theme-purple menu_null">');
      windowP.document.write(content);
      for (var i = 0; i < _script.length; i++)
        windowP.document.write(_script[i].outerHTML);
      windowP.document.write('</body></html>');
      windowP.document.close();
      setTimeout(() => windowP.print(),2000);
      //windowP.print();
      console.log(content);
    } else {
      this.snack.open('دیتا برای پرینت وجود ندارد.', '', { duration: 5000 });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/student-finance-report/student-finance-report.component.ts